import { render, staticRenderFns } from "./SkillsGroup.vue?vue&type=template&id=7cab0435&scoped=true"
import script from "./SkillsGroup.vue?vue&type=script&lang=ts"
export * from "./SkillsGroup.vue?vue&type=script&lang=ts"
import style0 from "./SkillsGroup.vue?vue&type=style&index=0&id=7cab0435&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cab0435",
  null
  
)

export default component.exports